// src/components/home/Hero/Hero.js
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';
import AbhyaasLogo from '../../../assets/images/AbhyaasLogoSquareTransparent.svg';

const Hero = () => {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        setIsLoaded(true);
    }, []);

    const scrollToAdmissions = () => {
        const admissionsSection = document.getElementById('admissions');
        if (admissionsSection) {
            const yOffset = -80;
            const y = admissionsSection.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    };

    return (
        <section className={`hero ${isLoaded ? 'hero--loaded' : ''}`} id="hero">
            {/* Animated background layers */}
            <div className="hero__bg">
                <div className="hero__gradient"></div>
                <div className="hero__mesh"></div>
                <div className="hero__orbs">
                    <div className="hero__orb hero__orb--1"></div>
                    <div className="hero__orb hero__orb--2"></div>
                    <div className="hero__orb hero__orb--3"></div>
                </div>
                <div className="hero__grid"></div>
                <div className="hero__noise"></div>
            </div>

            <div className="hero__container">
                {/* Logo with glow effect */}
                <div className="hero__logo-wrap">
                    <div className="hero__logo-glow"></div>
                    <img
                        src={AbhyaasLogo}
                        alt="Abhyaas Educational Trust"
                        className="hero__logo"
                    />
                </div>

                {/* Main content */}
                <div className="hero__content">
                    <h1 className="hero__title">
                        <span className="hero__title-line hero__title-line--1">
                            Where Young
                        </span>
                        <span className="hero__title-line hero__title-line--2">
                            <span className="hero__title-accent">Minds</span> Flourish
                        </span>
                    </h1>

                    <p className="hero__subtitle">
                        Nurturing curiosity, creativity, and confidence through
                        thoughtfully designed early education experiences.
                    </p>

                    {/* CTA Buttons */}
                    <div className="hero__actions">
                        <Link to="/schools/little-elly-kudlu" className="hero__btn hero__btn--primary">
                            <span>Discover Little Elly</span>
                            <svg className="hero__btn-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M5 12h14M12 5l7 7-7 7"/>
                            </svg>
                        </Link>

                        <button onClick={scrollToAdmissions} className="hero__btn hero__btn--glass">
                            <span className="hero__btn-pulse"></span>
                            <span>Admissions 2026-27</span>
                        </button>
                    </div>
                </div>

                {/* Stats bar */}
                <div className="hero__stats">
                    <div className="hero__stat">
                        <span className="hero__stat-value">5+</span>
                        <span className="hero__stat-label">Years of Excellence</span>
                    </div>
                    <div className="hero__stat-divider"></div>
                    <div className="hero__stat">
                        <span className="hero__stat-value">200+</span>
                        <span className="hero__stat-label">Happy Students</span>
                    </div>
                    <div className="hero__stat-divider"></div>
                    <div className="hero__stat">
                        <span className="hero__stat-value">15+</span>
                        <span className="hero__stat-label">Dedicated Educators</span>
                    </div>
                </div>
            </div>

            {/* Scroll indicator */}
            <div className="hero__scroll">
                <div className="hero__scroll-line"></div>
                <span>Scroll</span>
            </div>
        </section>
    );
};

export default Hero;
